import { FC, ReactNode } from "react";
import FullScreenLoader from "@/components/FullScreenLoader";
import { LogoIcon } from "@/assets/images";
import Footer from "@/components/Footer";

interface PageLayoutProps {
  children: ReactNode;
  loading: boolean;
  isWelcomeShown?: boolean;
  error?: boolean;
}

const PageLayout: FC<PageLayoutProps> = ({
  children,
  loading,
  isWelcomeShown,
}) => {
  return (
    <div className="relative overlay flex flex-col justify-between min-h-screen">
      <header>
        <FullScreenLoader isLoading={loading} />
        <div className="h-40 sm:h-60 lg:h-80 bg-light-pink flex justify-center">
          <LogoIcon />
        </div>
      </header>
      <main className="flex-grow mb-2 sm:mb-3 lg:mb-4">{children}</main>
      {isWelcomeShown && <Footer />}
    </div>
  );
};

export default PageLayout;
